export const ANALYTICS_CHANNEL = 'navigation';
export const NAV_STATE_LS_KEY = 'navx-temp-sidebar-state';
